import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import moment from "moment";
import DataTable from "react-data-table-component";
import { NotificationManager } from "react-notifications";
import { makeStyles } from "@mui/styles";
import LinearProgress from "@mui/material/LinearProgress";
import Tooltip from "@mui/material/Tooltip";
import VisibilityIcon from "@mui/icons-material/Visibility";
import EditIcon from "@mui/icons-material/Edit";
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import styles from "assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.js";
import { deleteGEBScript } from "services/ConfigServices";
import useScriptsTable from "./useScriptsTable.js";
import CustomDeleteButton from "components/CustomDeleteButton/CustomDeleteButton.js";
import UserService from "services/UserService";
import Button from "components/CustomButtons/Button.js";
import styled from "styled-components";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import { scriptText } from "variables/MBM/geb";
import { typeData } from "variables/MBM/lists/schedule";
import { dico } from "variables/lists/dico";
import Chip from "@mui/material/Chip";
import Dialog from "@mui/material/Dialog";
import { withStyles } from "@mui/styles";
import MuiDialogContent from "@mui/material/DialogContent";
import MuiDialogActions from "@mui/material/DialogActions";
import CustomDialogTitle from "components/Dialog/CustomDialogTitle.js";
import ScriptDialog from "./ScriptDialog.js";
// import ScheduleDialog from "./ScheduleDialog";

const GroupCell = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
`;

const Container = styled.div`
  border: solid;
  border-width: 1px;
  border-color: #EEEEEE;
  background-color: white;
  margin-top: -0.5px;
  padding-top: 5px;
  overflow-x: auto;
  width: 100%;
`;

const ExpandableContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0.5rem 4rem 2rem;
`;
const ExpandableElement = styled.div`
  display: flex;
  flex-direction: row;
  margin-left: ${(props) => props.marginleft};
`;

const ElementTitle = styled.div`
  font-weight: 600;
  font-size: 12px;
  font-family: "Source Sans Pro",sans-serif;
`;

const ElementData = styled.div`
  margin-left: 4px;
  font-weight: 400;
  font-size: 12px;
  font-family: "Source Sans Pro",sans-serif;
`;

const NoData = styled.p`
  font-size: 14px;
  font-weight: 600;
  margin-top: 20px;
  opacity: 1;
`;


const DialogContent = withStyles((theme) => ({
  root: {
    padding: '16px',
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: '8px',
  },
}))(MuiDialogActions);

const useStyles = makeStyles(styles);

const RTScripts = (props) => {
  const permis = JSON.parse(localStorage.getItem("permission")) || [];
  const mbm_admin = permis.includes("mbm_admin");
  const appContext = useContext(AdvancedSearchContext);
  const {currentWorkspace} = props;
  const { chartIdGroup, groupInfoListById } = appContext;
  const [open, setOpen] = useState(false);
  const [currentScript, setCurrentScript] = useState(null);
  const { gridState, refetch, setSelectedScripts, setLoading } = useScriptsTable(currentWorkspace);


  const classes = useStyles();

  const columns = [
    {
      name: scriptText.name,
      selector: (row) => row.parameters?.name,
      sortable: true,
      maxWidth: "12rem",
      cell: (row) => row.parameters?.name,
    },
    {
      name: scriptText.description,
      selector: (row) => row.parameters?.description,
      sortable: true,
      maxWidth: "12rem",
      cell: (row) => row.parameters?.description,
    },
    {
      name: scriptText.author,
      selector: (row) => row.parameters?.authorname,
      sortable: true,
      maxWidth: "12rem",
      cell: (row) => row.parameters?.authorname,
    },
    {
      name: scriptText.modifier,
      selector: (row) => row.parameters?.modifiername,
      sortable: true,
      maxWidth: "12rem",
      cell: (row) => row.parameters?.modifiername,
    },
    {
      name: scriptText.lastupdate,
      selector: (row) => row.parameters?.lastupdate,
      sortable: true,
      maxWidth: "12rem",
      cell: (row) =>
        row.parameters?.lastupdate && moment(row.parameters?.lastupdate).isValid()
          ? moment(row.parameters?.lastupdate).format("DD/MM/YYYY HH:mm")
          : "",
    },
    {
      name: "",
      sortable: false,
      width: "10rem",
      // eslint-disable-next-line react/button-has-type
      // eslint-disable-next-line react/display-name
      cell: (row) => (
        <>
          <div className="actions-right">
            {mbm_admin && (
              <>
                <Tooltip title="Editer le script">
                  <Button
                    onClick={editScript(row)}
                    color={"warning"}
                    className={classes.actionButton}
                  >
                    <EditIcon fontSize="large" />
                  </Button>
                </Tooltip>
                <Tooltip title="Supprimer le script">
                  <CustomDeleteButton
                    deleteTitle={"Suppression du script"}
                    deleteSubTitle={`Êtes-vous sûr de vouloir supprimer le script ${row.parameters?.name}?`}
                    handleSupprimer={deleteScriptFunction(row)}
                  />
                </Tooltip>
              </>
            )}
          </div>
        </>
      ),
    },
  ];


  const ExpandableComponent = props => {
    const { data } = props;
    return (
      <Container>

      </Container>
    );
  };

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleEditClose = () => {
    setOpen(false);
  };

  const editScript = (row) => async () => {
    let obj = gridState.data.find((o) => o.id === row.id);
    if (obj) {
      setCurrentScript(obj);
      handleClickOpen();
    }
  }

  const deleteScriptFunction = (row) => async () => {
    let obj = gridState.data.find((o) => o.id === row.id);
    let idSelected = obj.id;
    let url = deleteGEBScript(idSelected);
    axios
      .delete(url,
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
          },
        })
      .then((res) => {
        if (res.status == 200) {
          setNotification(
            "success",
            `Le script a été supprimé`
          );
          refetch();
        } else setNotification("error", "Une erreur est survenue");
      })
      .catch((error) => {
        setNotification("error", "Une erreur est survenue");
      });
  };

  const setNotification = (status, text) => {
    if (status === "success") {
      NotificationManager.success(text);
    } else {
      NotificationManager.error(text);
    }
  };

  const handleSelectedRowsChange = (selection) => {
    setSelectedScripts(selection.selectedRows);
  };


  return (
    <>
      <DataTable
          paginationRowsPerPageOptions={[10,20,30,50,100]}
        noDataComponent={<NoData>Aucun script à afficher</NoData>}
        noHeader={true}
        columns={columns}
        persistTableHead
        pagination
        subHeader
        onSelectedRowsChange={handleSelectedRowsChange}
        selectableRows={true}
        progressPending={gridState.loading}
        progressComponent={<LinearProgress />}
        // expandOnRowClicked={true}
        // expandableRows={true}
        // expandableRowDisabled={(row) => row.disabled}
        // expandableRowsComponent={ExpandableComponent}
        paginationComponentOptions={{
          noRowsPerPage: false,
          rowsPerPageText: "Lignes par page",
          rangeSeparatorText: "sur",
          selectAllRowsItem: false,
          selectAllRowsItemText: "Selectionner toutes les lignes",
        }}
        {...gridState}
      />
      <Dialog
        onClose={handleEditClose}
        aria-labelledby="edituser-dialog-title"
        fullWidth="true"
        maxWidth="md"
        open={open}
      >
        <CustomDialogTitle id="customized-dialog-title" onClose={handleEditClose}>
          Modification d'un script
        </CustomDialogTitle>
        <DialogContent dividers>
          <ScriptDialog
            closeModal={handleEditClose}
            setLoading={setLoading}
            setNotification={setNotification}
            refetch={refetch}
            currentScript={currentScript}
            wpgroup={currentWorkspace?.idgroup}
            workspaceid={currentWorkspace?.id}
          />
        </DialogContent>
        <DialogActions></DialogActions>
      </Dialog>
    </>
  );
};

export default RTScripts;
